// extracted by mini-css-extract-plugin
module.exports = {"section":"style_section__3yL8Z","btnWrapper":"style_btnWrapper__1PZHA"};